@if (quote(); as quote) {
<div class="flex flex-col gap-6">
  <div class="flex flex-col">
    <h2 class="text-lg font-semibold text-gray-900">
      Cotización #{{ quote?.internalNumber }}
    </h2>
    <activar-badge
      [status]="quote.badgeStatus"
      [text]="quote.badgeText"
    ></activar-badge>
  </div>

  <app-quote-info></app-quote-info>
  <app-user-resume [user]="quote.user"/>

  @for (coverage of coverages(); track coverage.id) {
  <app-quote-coverage-card [coverage]="coverage" [quoteStatus]="quote.status"/>
  }
  @if(quote.additionalCoverage &&  quote.additionalCoverage.id){
    <app-quote-coverage-card [coverage]="quote.additionalCoverage" [quoteStatus]="quote.status"/>
  }
  @if(quote.risk.tag === 'quad'){
  <app-disclaimer
    text="Para cuatriciclos y areneros la cobertura de garage es obligatoria. Sólo se cubrirán vehículos patentados y mientras circulen en vías habilitadas."
  />
  }
</div>
}
